export const maxicaBrand = {
  name: "Bodega Mayorista Maxica",
  headline: "Tu proveedor de confianza.",
  subheadline: "Calidad, precio y grupos por línea para comprar mejor.",
  logo: "img/maxica-logo.jpg",
  phone: "573125798515",
  address: "Calle 37 #7-66, barrio Alfonso López, Bucaramanga",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Calle%2037%20%237-66%20Alfonso%20Lopez%20Bucaramanga",
  catalogUrl: "https://maxica.com.co/#/tienda",
  groupsUrl: "https://maxica.com.co/links/",
  externalLinktree:
    "https://linktr.ee/bodegamaxica?utm_source=linktree_profile_share&ltsid=51091e10-28ad-427e-ae61-c58773a76cdb",
};

export const socialLinks = [
  {
    title: "Instagram",
    icon: "mdi-instagram",
    url: "https://instagram.com/bodegamayorista_maxica",
  },
  {
    title: "Facebook",
    icon: "mdi-facebook",
    url: "https://www.facebook.com/share/1BWwr7KbJM/",
  },
  {
    title: "TikTok",
    icon: "mdi-music-note",
    url: "https://tiktok.com/@maxica.mxc",
  },
];

export const quickActions = [
  {
    title: "Ubicación",
    text: "Calle 37 #7-66, Bucaramanga",
    icon: "mdi-map-marker-radius-outline",
    url: maxicaBrand.mapsUrl,
  },
  {
    title: "Grupos mayoristas",
    text: "Comunidades por línea",
    icon: "mdi-whatsapp",
    url: maxicaBrand.groupsUrl,
  },
  {
    title: "Catálogo web",
    text: "Mira productos y referencias",
    icon: "mdi-storefront-outline",
    url: maxicaBrand.catalogUrl,
  },
];

export const wholesaleGroups = [
  {
    order: 3,
    title: "Maxica Principal",
    text: "Novedades generales para mayoristas",
    icon: "mdi-shopping-outline",
    accent: "#d9b45f",
    thumb: maxicaBrand.logo,
    url: "https://chat.whatsapp.com/C81lwLZtFap3md0lsCBCzX?mode=ac_t",
  },
  {
    order: 5,
    title: "Maxica Jeans",
    text: "Jeans y prendas de temporada",
    icon: "mdi-hanger",
    accent: "#4b7a7f",
    thumb: maxicaBrand.logo,
    url: "https://chat.whatsapp.com/FKftJQ3gAnEARfa4SKc0KV",
  },
  {
    order: 6,
    title: "Maxica Bolsos",
    text: "Bolsos, carteras y accesorios",
    icon: "mdi-bag-personal-outline",
    accent: "#a15d43",
    thumb: maxicaBrand.logo,
    url: "https://chat.whatsapp.com/J7Zifac1rwvD2s5RDwp3r5",
  },
  {
    order: 7,
    title: "Calzado Maxica",
    text: "Calzado y referencias nuevas",
    icon: "mdi-shoe-sneaker",
    accent: "#7d6b5b",
    thumb: maxicaBrand.logo,
    url: "https://chat.whatsapp.com/ClzHQ46aBC71wPJnh9cR8P",
  },
  {
    order: 2,
    title: "Maxica Kids",
    text: "Línea infantil",
    icon: "mdi-baby-face-outline",
    accent: "#7a5f8f",
    thumb: maxicaBrand.logo,
    url: "https://chat.whatsapp.com/EbQcmPeC1UFFWpPXjLm4JK",
  },
  {
    order: 1,
    title: "Deportivos Maxica",
    text: "Ropa y conjuntos deportivos",
    icon: "mdi-run",
    accent: "#416b58",
    thumb: maxicaBrand.logo,
    url: "https://chat.whatsapp.com/GUnvVxp5tcg9M5xoEVHMzD",
  },
  {
    order: 4,
    title: "Maquillaje",
    text: "Belleza, maquillaje y cosméticos",
    icon: "mdi-lipstick",
    accent: "#a25b6a",
    thumb: maxicaBrand.logo,
    url: "https://chat.whatsapp.com/C2QI6BbNL39IfVIGLeTbAB?mode=wwt",
  },
  {
    order: 8,
    title: "Promo Maxica",
    text: "Promociones y oportunidades",
    icon: "mdi-sale-outline",
    accent: "#bf7b35",
    thumb: maxicaBrand.logo,
    url: "https://chat.whatsapp.com/Ek1qrid8Nnc0DCcFiLOD9L",
  },
  {
    order: 9,
    title: "Hogar Maxica",
    text: "Productos para hogar",
    icon: "mdi-home-outline",
    accent: "#5d736c",
    thumb: maxicaBrand.logo,
    url: "https://chat.whatsapp.com/I05IWFSpDh2EYRKwLtkeJl",
  },
  {
    order: 10,
    title: "Lencería y Ropa Interior",
    text: "Línea interior y prendas base",
    icon: "mdi-tshirt-crew-outline",
    accent: "#8f5f5c",
    thumb: maxicaBrand.logo,
    url: "https://chat.whatsapp.com/CBS174at2dU7vuo6yVBfj0",
  },
];
